import { Component, HostListener, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Observable, Subscription } from 'rxjs';

export interface SimpleDialogButton {
  label: Observable<string>;
  onClick: () => Observable<boolean>;
}

export interface SimpleDialogOptions {
  theme?: string;
  title: Observable<string>;
  message: Observable<string>;
  onClose?: () => Observable<boolean>;
  buttons?: SimpleDialogButton[];
}

export type SimpleDialogResponse = void;

@Component({
  selector: 'app-simple-dialog',
  templateUrl: './simple-dialog.component.html',
  styleUrls: ['./simple-dialog.component.scss'],
})
export class SimpleDialogComponent {
  subscription?: Subscription | null;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: SimpleDialogOptions,
    private dialogRef: MatDialogRef<SimpleDialogComponent, SimpleDialogResponse>,
  ) {
    dialogRef.backdropClick().subscribe(() => this.close());
  }

  handleAction(action: () => Observable<boolean>): void {
    this.subscription = action().subscribe(
      (result) => {
        this.subscription = null;
        if (result) {
          this.dialogRef.close();
        }
      },
      (error) => {
        console.error('Failed to perform action', error);
        this.subscription = null;
      },
    );
  }

  @HostListener('window:keyup.esc')
  close(): void {
    if (this.data.onClose != null) {
      this.handleAction(this.data.onClose);
    } else {
      this.dialogRef.close();
    }
  }
}
